import { ovl } from "../../../../../../../_ovlclient/src"

import type {
  SYSAction,
  SYSLongRunningProcess,
  SYSState,
} from "../../../../../../../_ovlclient/src"
import { Data } from "../../../../../../../_ovlclient/src/dataapi"
import {
  ProcessEnd,
  ProcessIsRunning,
  ProcessStart,
} from "../../../../../../../_ovlclient/src/library/longrunningprocesstracker/processapi"
import {
  ScreenCurrent,
  ScreenCurrentState,
} from "../../../../../../../_ovlclient/src/library/screenapi"
import {
  SnackAdd,
  SnackTrackedReplaceContent,
} from "../../../../../../../_ovlclient/src/library/snackapi"
import {
  TableRebuild,
  TableRefresh,
} from "../../../../../../../_ovlclient/src/library/table/tableapi"
import { T } from "../../../../../../../_ovlclient/src/textapi"
import {
  OfferingDetailsRefresh,
  ResetDetailChanges,
} from "../../../screens/qutoffering/offering/details/helpers"
import type { OfferingStatus } from "../../../screens/qutoffering/offering/helpers"

// expects the docentry to show progress on
let progressTimer: any
let snackId

let debounceSuccessAndReset

let _ovl: SYSState
const offeringProgress = async (
  docEntry: number,
  offeringState: typeof _ovl.app.features.QUTOffering,
  offeringTable: typeof _ovl.app.global.QUT.tables.QUTOffering,
  snackStarted: boolean,
  state: SYSState,

  clearError: boolean = false,
  setStatus: OfferingStatus,
  snackKey: SYSLongRunningProcess
) => {
  let setStatusParam = <string>setStatus
  if (!setStatus) {
    setStatusParam = ""
  } else {
    setStatusParam = `&setStatus=${setStatus}`
  }

  try {
    let res = await Data(
      `offering/getstatus?id=${docEntry}&clearError=${clearError}${setStatusParam}`,
      undefined,
      { method: "GET", suppressFeedbackSnack: true }
    )

    let status: OfferingStatus = res.data.Status
    let error: string = res.data.Error
    let docTotal: number = res.data.DocTotal
    let fileName = res.data.FileName
    let idx = offeringTable.index[docEntry]
    let statusChanged = offeringState.lastProgressStatus !== status
    if (status !== "Canceled") {
      offeringTable.data[idx]["U_ITF_PRT_OfferError"] = error
      offeringTable.data[idx]["DocTotal"] = docTotal
      offeringTable.data[idx]["U_ITF_PRT_FileName"] = fileName
      if (statusChanged) {
        offeringTable.data[idx]["U_ITF_PRT_OfferStatus"] = status
      }
    }
    let doNotShowInThisScreen =
      "QUTOffering,QUTOfferingAdmin,QUTOfferingAdminCut,QUTOfferingDetails,".indexOf(
        `${ScreenCurrent()},`
      ) < 0
    if (
      status === "Ready" ||
      status === "Accepted" ||
      status === "Canceled" ||
      error ||
      doNotShowInThisScreen
    ) {
      if (snackStarted) {
        ProcessEnd(snackKey, docEntry.toString())
      }

      if (debounceSuccessAndReset) {
        clearTimeout(debounceSuccessAndReset)
      }
      debounceSuccessAndReset = setTimeout(async () => {
        if (
          error &&
          (ScreenCurrent() !== "QUTOfferingDetails" ||
            idx === offeringState.selectedOfferKey)
        ) {
          let noPartsErr = "NoPartsFound"

          if (error.indexOf(noPartsErr) > -1) {
            error = T(`QUTOfferingOfferingError${noPartsErr}`)
          }
          SnackAdd(error, "Error", 7000)
        } else if (status === "Ready" || status === "Accepted") {
          SnackAdd(T("QUTOfferingOfferingOfferSuccessful"), "Success", 10000)
          ResetDetailChanges()
          let screenState = ScreenCurrentState()
          if (
            screenState.screen === "QUTOfferingDetails" ||
            snackKey === "QUTOfferingRecalcStatus"
          ) {
            await OfferingDetailsRefresh(
              state,
              ovl.getActions(),
              screenState.instance,
              true
            )
          }
        }
      }, 500)
      offeringState.lastProgressStatus = undefined
      return
    }

    if (statusChanged) {
      // // we got a change so change Snack
      let displayStatus = T(`QUTOfferingOfferingStatus${status}`)
      let msg = T("QUTOfferingOfferingProgress", [displayStatus])
      if (snackStarted && ProcessIsRunning(snackKey, docEntry.toString())) {
        SnackTrackedReplaceContent({
          content: msg,
          key: snackId,
        })
      } else {
        snackId = ProcessStart(snackKey, {
          instance: docEntry.toString(),
          snack: { type: "BusyIndicator", text: msg },
        }).trackedSnackId
      }
      snackStarted = true
      offeringState.lastProgressStatus = status
    }

    if (state.ovl.screens.nav.nextScreen.indexOf("QUTOffering") < 0) {
      if (snackStarted) {
        ProcessEnd(snackKey, docEntry.toString())
      }
      offeringState.lastProgressStatus = undefined
      return
    }
  } catch (e) {
    if (snackStarted) {
      ProcessEnd(snackKey, docEntry.toString())
    }
    offeringState.lastProgressStatus = undefined
  }
  progressTimer = setTimeout(
    () =>
      offeringProgress(
        docEntry,
        offeringState,
        offeringTable,
        snackStarted,
        state,

        false,
        undefined,
        snackKey
      ),
    10000
  )
}

const ShowOfferingProgress: SYSAction<{
  docEntry: number
  clearError: boolean
  setStatus?: OfferingStatus
  snackKey?: SYSLongRunningProcess
}> = async ({ docEntry, clearError, setStatus, snackKey }, { global }) => {
  let state = global.getState()
  let offeringTable = state.app.global.QUT.tables.QUTOffering
  let offeringState = state.app.features.QUTOffering
  let snackStarted = false
  state.app.features.QUTOffering.lastProgressStatus = undefined
  if (clearError === undefined) {
    clearError = false
  }
  if (!snackKey) {
    snackKey = "OfferingStatus"
  }

  await offeringProgress(
    docEntry,
    offeringState,
    offeringTable,
    snackStarted,
    state,

    clearError,
    setStatus,
    snackKey
  )
}
const LinkSalesCalc: SYSAction<{
  docEntry: number
  offerEntry: number
  unLink: boolean
}> = async ({ docEntry, offerEntry, unLink }, { global }) => {
  let state = global.getState()
  let res = await Data("offering/offeringsalescalc_link", {
    docEntry,
    offerEntry,
    unLink,
  })

  let updatedSalesCalc
  if (res.data.length > 0) {
    updatedSalesCalc = res.data[0]
  }
  let indexToUpdate =
    state.app.features.QUTOffering.adminSalesCalcResult.findIndex(
      (f) => f.DocEntry == docEntry
    )
  if (indexToUpdate > -1) {
    if (updatedSalesCalc) {
      state.app.features.QUTOffering.adminSalesCalcResult[indexToUpdate] =
        updatedSalesCalc
    } else {
      state.app.features.QUTOffering.adminSalesCalcResult.splice(
        indexToUpdate,
        1
      )
    }
  }

  await TableRefresh("QUTOffering", {
    serverFilter: { DocEntry: offerEntry },
  })
  await TableRebuild("QUTOfferingActual")
}

export let actions = { ShowOfferingProgress, LinkSalesCalc }
